import { render, staticRenderFns } from "./input-select.vue?vue&type=template&id=3605fb5e&scoped=true"
import script from "./input-select.ts?vue&type=script&lang=ts&external"
export * from "./input-select.ts?vue&type=script&lang=ts&external"
import style0 from "./input-select.vue?vue&type=style&index=0&id=3605fb5e&prod&lang=scss"
import style1 from "./input-select.vue?vue&type=style&index=1&id=3605fb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3605fb5e",
  null
  
)

export default component.exports